import { createSelector } from 'reselect';

import getShopAPI from '@core/reducers/shop/selectors/getShop';
import { getRouterState } from '@shared/selectors';

const getShop = createSelector(
  getShopAPI,
  getRouterState,
  (shopApi, routerShop) => {
    const shop = shopApi || routerShop;
    return shop;
  },
);

export default getShop;
